import { useCallback, useEffect, useMemo, useState } from 'react';
import useUser from '@hooks/useUser';
import { ManagedEventsContext, ManagedEventsContextValues } from '@hooks/useManagedEvents';
import { EventRoleStatus } from '@type/db-types';
import { fetchManageableEvents } from '@modules/supabase/events';

export default function ManagedEventsProvider({
    children,
}: {
    children: React.JSX.Element;
}): React.JSX.Element {
    const { user } = useUser();
    const [managedEvents, setManagedEvents] = useState<EventRoleStatus[] | null>(null);

    const refresh = useCallback(() => fetchManageableEvents().then(setManagedEvents), []);

    useEffect(() => {
        if (user?.id) refresh();
    }, [user?.id, refresh]);

    // console.log('managedEvents', managedEvents);

    const managedEventsContext: ManagedEventsContextValues = useMemo(() => {
        return { refresh, managedEvents: managedEvents || [], loading: managedEvents === null };
    }, [managedEvents, refresh]);

    return (
        <ManagedEventsContext.Provider value={managedEventsContext}>
            {children}
        </ManagedEventsContext.Provider>
    );
}
